exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-control[data-v-668f0afd] {\n  padding-left: 1.85rem;\n}\n.cursor-pointer[data-v-668f0afd] {\n  cursor: pointer;\n}\n", ""]);

// exports
